export default __webpack_public_path__ + "static/media/SmashHaus_LOGO_cmyk.7d750c7a.png";